<template>
  <v-dialog v-model="visible" max-width="4in">
    <v-card>
      <v-card-text>
        <h1>Create</h1>
        <p>QuickChords charts can be created from scratch or adapted from other charts.
        You use a simple text-based language to define the structure and content.
        </p>
        <p>We provide a free, dedicated application called QuickChords Creator for managing your creations.</p>
        <v-btn @click="onGoto">Goto QuickChords Creator</v-btn>
        <hr/>
        <p>Here is a sample chart.</p>
        <v-textarea ref="textArea" class="ta" v-model="data" box auto-grow></v-textarea>
        <!--<div>[qc];c ; f ; g ; c ;;;[/qc]</div>-->
        
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "CreateDialog",
    components: {},
    data: function () {
      return {
        visible: false,
        data: `:title My Chart
:artist Me

(Verse)
[ C ; F ; C ; C
; C ; F ; C ; G

(Chorus)
; F ; G ; F ; G 
; F ; G ; F ; C ]
`
      }
    },
    props: {},
    methods: {
      show() {
        this.visible = true
      },
      onGoto() {
        window.open('https://www.quickchords.org/', '_blank')
      }
    }
  }
</script>

<style scoped>
  .ta {
    flex: 1
  }
</style>